import { AI_REVIEW_SOURCE, AI_REVIEW_TEXT_COLOR } from './types';

export function aiRecommendationToAnnotationText(item, role = 'teacher') {
  return {
    x: Number(item.x) || 0.72,
    y: Number(item.y) || 0.08,
    text: String(item.text || '').trim(),
    color: AI_REVIEW_TEXT_COLOR,
    fontSize: 0.022,
    role,
    source: AI_REVIEW_SOURCE,
    aiRecommendationId: item.id,
  };
}

export function groupAiRecommendationsByPage(recommendations, role = 'teacher') {
  return recommendations.reduce((acc, item) => {
    const text = aiRecommendationToAnnotationText(item, role);
    if (!text.text) return acc;
    const pageIndex = Math.max(0, Number(item.page || 1) - 1);
    const pageKey = String(pageIndex);
    acc[pageKey] = [...(acc[pageKey] || []), text];
    return acc;
  }, {});
}

